var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.shouldShowFloatingWindow)?_c('FloatingWindow',{attrs:{"title":"下载APP"},on:{"action":_vm.handleFloatingAction}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }